import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsContactlesspaymentComponent } from './simple-icons-contactlesspayment.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsContactlesspaymentComponent ],
    exports:      [ SimpleIconsContactlesspaymentComponent ],
    bootstrap:    []
})
export class SimpleIconsContactlesspaymentModule {}
